/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Createaccount1Inputs */

const zh_auth_createaccount1 = /** @type {(inputs: Auth_Createaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建账户`)
};

const en_auth_createaccount1 = /** @type {(inputs: Auth_Createaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Account`)
};

const es_auth_createaccount1 = /** @type {(inputs: Auth_Createaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear cuenta`)
};

/**
* | output |
* | --- |
* | "Create Account" |
*
* @param {Auth_Createaccount1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_createaccount1 = /** @type {((inputs?: Auth_Createaccount1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Createaccount1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_createaccount1(inputs)
	if (locale === "en") return en_auth_createaccount1(inputs)
	return es_auth_createaccount1(inputs)
});
export { auth_createaccount1 as "auth_createAccount" }